import { useState } from 'react'
import { lensMapDataUrl } from './lens-map'
import { LENS_FILTER_ID } from './lens-filter-id'

const LENS_MAP_OPTIONS = { width: 256, height: 256, radius: 56, bevel: 40, strength: 1 }
/** feDisplacementMap desloca scale * (canal/255 - 0.5); scale = 2 * px máximo. */
const SCALE = 2 * 14

/**
 * Monta uma vez, no shell. O SVG é invisível e serve só de <defs>
 * para o backdrop-filter das superfícies lens apontarem.
 *
 * O data URL do mapa sai do inicializador preguiçoso de useState — roda
 * uma vez, no primeiro render, sem o cascading render de um setState
 * dentro de useEffect.
 */
export function LensDefs() {
  const [href] = useState(() => lensMapDataUrl(LENS_MAP_OPTIONS))

  if (!href) return null

  return (
    <svg aria-hidden width="0" height="0" style={{ position: 'absolute' }}>
      <defs>
        <filter
          id={LENS_FILTER_ID}
          x="0"
          y="0"
          width="100%"
          height="100%"
          colorInterpolationFilters="sRGB"
        >
          <feImage href={href} result="displacementMap" preserveAspectRatio="none" />
          <feDisplacementMap
            in="SourceGraphic"
            in2="displacementMap"
            scale={SCALE}
            xChannelSelector="R"
            yChannelSelector="G"
          />
        </filter>

      </defs>
    </svg>
  )
}
